import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=047317a8&scoped=true"
import script from "./freight.vue?vue&type=script&lang=js"
export * from "./freight.vue?vue&type=script&lang=js"
import style0 from "./freight.vue?vue&type=style&index=0&id=047317a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047317a8",
  null
  
)

export default component.exports